import styled from 'styled-components'

export const AccessibleTitle = styled.h1`
  ${({ theme }) => theme.textStyles.accessibleHiddenText}
`
